import { render, staticRenderFns } from "./TrendKeyword.vue?vue&type=template&id=dc4f95c8"
import script from "./TrendKeyword.vue?vue&type=script&lang=js"
export * from "./TrendKeyword.vue?vue&type=script&lang=js"
import style0 from "./TrendKeyword.vue?vue&type=style&index=0&id=dc4f95c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports